export default "__VITE_ASSET__65c7ab3b__"